export default "__VITE_ASSET__C6HG4iQJ__"